<template>
    <div >
        <splide :options="options">
            <splide-slide v-for="(picture, index) in pictures"
                          v-bind:data="picture.path"
                          v-bind:key="index">
                <img :src="picture.path">
            </splide-slide>
        </splide>
    </div>

</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
    name: "PortfolioSlider",
    props: ['pictures'],
    components: {
        Splide,
        SplideSlide,
    },
    data() {
        return {
            options: {
                rewind : true,
                gap    : '1rem',
                type   : 'loop',
                padding: {
                    right: '5rem',
                    left : '5rem',
                },
                // height: '550px',
                // cover  : true,
                autoWidth: true,
                focus    : 'center',
            },
        };
    },
}
</script>

<style scoped>

</style>
